let highlighterOffset = 0;

const get = () => highlighterOffset;
const set = (value) => {
  highlighterOffset = value;
};

export default { get, set };
